<!-- 家长监护-家长监护 -->
<template>
  <div class="guard">
    <img class="banner" src="https://cdn.welove520.com/static/res/vue/playbay/banner.png">
    <div class="safe">
      <img src="https://cdn.welove520.com/static/res/vue/playbay/safe_icon.png">
      <span class="title">网络游戏未成年人家长监护工程</span>
    </div>
    <p class="content">“网络游戏未成年人家长监护工程”是一项由网页游戏平台根据国家有关规定而发起的一个项目，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。它提供了一种切实可行的方法，一种家长实施监控的管道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注及对用实际行动营造和谐社会的愿望。</p>
    <p class="title splite">《未成年人健康参与网络游戏提示》</p>
    <p class="content">随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：</p>
    <p class="content">一、主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。</p>
    <p class="content">二、不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。</p>
    <p class="content">三、不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。</p>
    <p class="content">四、养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。</p>
    <p class="content">五、注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。</p>

    <p class="title splite">家长监护服务说明：</p>
    <p class="content">家长监护系统充分考虑家长的实际需求，当家长发现自己的孩子玩游戏过于沉迷的时候，由家长提供合法的监护人资质证明、游戏名称账号、以及家长对于限制强度的愿望等信息，可对处于孩子游戏沉迷状态的账号采取几种限制措施，解决未成年人沉迷游戏的不良现象，如限制未成年人每天玩游戏的时间区间和长度，也可以限制只有节假日才可以游戏，或者完全禁止。 </p>

    <p class="title splite">家长监护服务进度查询：</p>
    <p class="content">如果您已经申请家长监护服务，在服务期间，当您对需要提交的信息、处理结果有疑问，或者其他任何问题，您均可以在工作时间联系我们，我们将由专门负责的受理专员为您提供咨询解答服务，或者配合、指导您解决问题。 </p>
    <Download/>
  </div>
</template>

<script>
import Download from "./Download";
export default {
  name: "Guard",
  data() {
    return {};
  },
  components: {
    Download: Download
  },
  created() {
    this.$store.dispatch("initTabName", "parents");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.guard {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
}

.banner {
  margin-top: 30px;
  width: 100%;
}

.safe {
  margin-top: 35px;
  margin-bottom: 30px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.safe > img {
  width: 20px;
}

.safe > span {
  margin-left: 20px;
}

.title {
  font-size: 20px;
  color: #303032;
  text-align: center;
}

.splite {
  margin: 50px 0 30px 0;  
}

.content {
  font-size: 16px;
  color: #303032;
  text-align: justify;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/Guard.vue